﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    /**
    * 
    */
    
    export class ApplicationSearchFilter extends SearchFilter {
        
        
        id?: number | null;
    }
